import React from "react";
import scottkutler from "./assets/scottkutler-new.png";
import WorkPanel from "./WorkPanel";

class About extends React.Component {
  render() {
    return (
      <div className="about-page">
        <div className="aboutme-content animate fade-in-from-bottom">
          <div className="aboutme-box">
            <img
              alt="Scott Kutler portrait"
              className="scottkutler animate fade-in-from-bottom"
              src={scottkutler}
            />
            <div className="resume-aboutme">
              <div className="c23 animate fade-in-from-bottom">
                Scott Kutler<br />
              </div>
              <div data-delay="500" className="c24 animate fade-in-from-bottom">
                Senior Software Engineer | React, TypeScript, Python & PHP
              </div>
              <br />
              <p data-delay="750" className="animate fade-in-from-bottom">I'm a senior software engineer and startup founder who has spent the last decade shipping production software — from React and Python applications for advocacy and nonprofit organizations to a social app I founded that has passed one million downloads. I do my best work on collaborative teams solving real problems under real constraints, and I gravitate toward work with positive social impact.</p>
            </div>
          </div>
        </div>

        <div id="Experience">
          <br />
          <div className="WorkPanel-container animate fade-in-from-bottom">
            <h1 className="experience-header">Experience</h1>
            <WorkPanel />
            <div className="resume-flex-grid">
              <a href="/Scott-Kutler-Resume.pdf" target="_blank" rel="noopener noreferrer">
                <div className="FullResume">
                  <span className="resume-button">View Full Resume</span>
                </div>
              </a>
            </div>
          </div>
          <div className="skills-spacer" id="skills"><a name="Skills" id="Skills"></a></div>
                
        </div>

        <h1 className="skill-header animate fade-in-from-bottom">Skills</h1>
        <div className="skills-grid animate fade-in-from-bottom">
          <div className="skill-card"><h3>Front-End</h3><p>TypeScript<br />JavaScript (ES6+)<br />React / Redux / React Query / React Router<br />Vite &amp; Webpack<br />jQuery<br />HTML / CSS / SCSS<br />Responsive &amp; Accessible Design (WCAG)</p></div>
          <div className="skill-card"><h3>Backend &amp; APIs</h3><p>Python<br />Django &amp; Celery<br />FastAPI &amp; Pydantic<br />PHP (Laravel, Yii2)<br />Node.js / Express<br />REST API design &amp; integration<br />Axios</p></div>
          <div className="skill-card"><h3>Databases &amp; Data</h3><p>PostgreSQL<br />MySQL / MariaDB<br />Redis<br />SQL schema design &amp; migrations<br />ETL &amp; bulk data pipelines<br />BigQuery<br />GA4 Analytics Data API<br />Google Sheets API</p></div>
          <div className="skill-card"><h3>Mobile</h3><p>Swift (UIKit, StoreKit 2)<br />Java (Android SDK, Play Billing)<br />Firebase (FCM, Auth, Analytics)<br />App Store Connect<br />Google Play Console</p></div>
          <div className="skill-card"><h3>Cloud &amp; DevOps</h3><p>AWS / DigitalOcean<br />Docker<br />Nginx / Linux / Bash<br />Git / GitHub / Bitbucket<br />CI/CD</p></div>
          <div className="skill-card"><h3>Testing</h3><p>Jest / Vitest<br />React Testing Library<br />Enzyme / MSW<br />Pytest<br />Unit &amp; integration testing<br />End-to-end release QA</p></div>
          <div className="skill-card"><h3>CMS &amp; Integrations</h3><p>WordPress<br />Webflow<br />Stripe<br />HubSpot<br />SendGrid<br />NGP VAN / EveryAction<br />Chrome extensions</p></div>
          <div className="skill-card"><h3>Process &amp; Collaboration</h3><p>Agile / Scrum / Kanban<br />Jira &amp; Trello<br />Code review &amp; release management<br />Technical documentation<br />Remote collaboration</p></div>
          <div className="skill-card"><h3>Design &amp; Tools</h3><p>Figma / Sketch<br />Adobe Photoshop<br />Final Cut Pro (Certified)<br />VS Code / Cursor</p></div>
        </div>

      </div>
    );
  }
}

export default About;
